<header class="site-header">
  <div class="header-shell">
    <a class="brand" routerLink="/" fragment="top" (click)="closeMenu()" aria-label="D&D Twogether főoldal">
      <img src="assets/logo-black.svg" alt="D&D Twogether - Flowers and More" />
    </a>

    <nav class="desktop-nav" aria-label="Fő navigáció">
      <a routerLink="/" fragment="top">{{ 'NAV.HOME' | translate }}</a>
      <a routerLink="/szolgaltatasok">{{ 'NAV.SERVICES' | translate }}</a>
      <a routerLink="/rolunk">{{ 'NAV.ABOUT' | translate }}</a>
      <a routerLink="/kapcsolat">{{ 'NAV.VISIT_US' | translate }}</a>
    </nav>

    <div class="header-actions">
      <div class="social-links" aria-label="Közösségi média">
        <a href="https://facebook.com/twogetherflowers" target="_blank" rel="noopener" aria-label="Facebook">
          <img src="assets/facebook-icon-black.svg" alt="" />
        </a>
        <a href="https://instagram.com/twogetherflowers" target="_blank" rel="noopener" aria-label="Instagram">
          <img src="assets/instagram-black-icon.svg" alt="" />
        </a>
        <a href="https://www.tiktok.com/@twogetherflower" target="_blank" rel="noopener" aria-label="TikTok">
          <img src="assets/tiktok-icon-black.svg" alt="" />
        </a>
      </div>

      <div class="language-selector" aria-label="Nyelvválasztó">
        <button type="button" [class.active]="selectedLanguage === 'hu'" (click)="onLanguageChange('hu')">HU</button>
        <button type="button" [class.active]="selectedLanguage === 'en'" (click)="onLanguageChange('en')">EN</button>
      </div>

      <a
        class="shop-cta"
        href="https://shop.twogetherflower.hu"
        target="_blank"
        rel="noopener"
      >
        {{ 'NAV.SHOP' | translate }}
      </a>

      <a class="phone-cta" href="tel:+36300121051">
        <img src="assets/call-square-icon.svg" alt="" />
        <span>+36-30/012-1051</span>
      </a>

      <button
        class="menu-toggle"
        type="button"
        aria-label="Menü megnyitása"
        [attr.aria-expanded]="menuOpen"
        (click)="toggleMenu()"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </div>

  <nav class="mobile-nav" [class.open]="menuOpen" aria-label="Mobil navigáció">
    <a routerLink="/" fragment="top" (click)="closeMenu()">{{ 'NAV.HOME' | translate }}</a>
    <a routerLink="/szolgaltatasok" (click)="closeMenu()">{{ 'NAV.SERVICES' | translate }}</a>
    <a routerLink="/rolunk" (click)="closeMenu()">{{ 'NAV.ABOUT' | translate }}</a>
    <a routerLink="/kapcsolat" (click)="closeMenu()">{{ 'NAV.VISIT_US' | translate }}</a>
    <a href="https://shop.twogetherflower.hu" target="_blank" rel="noopener" (click)="closeMenu()">{{ 'NAV.SHOP' | translate }}</a>
  </nav>
</header>
